export default function skipBoundary({
  val,
  boundaryStart,
  boundaryEnd,
  goHigher = true,
}) {
  const isBetween = val > boundaryStart && val < boundaryEnd;

  if (isBetween) {
    return goHigher ? boundaryEnd : boundaryStart;
  } else {
    return val;
  }
}



// WEBPACK FOOTER //
// /Users/jamess/webdev/react-projects/materialish/docs/src/vendor/react-over/compute-position/skip-boundary.js